import head from 'lodash/head'
import get from 'lodash/get'

import {
  NEW_COLLECTION_STEPS,
  SEND_COLLECTION_NOTICE,
  NEW_TEAM_DATA,
  NEW_TEAM_EMAILS,


} from '../actions/collectionActions';

import {
  RESET_ACCOUNT,
  LOG_OUT

} from '../actions/accountActions';

const initialState = {
  invoice         : null,
  last_message    : null,
  steps           : null,
  teamCollection  : null

} // END initialState


export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch (type) {
    case NEW_COLLECTION_STEPS:
      newState = { steps: head(payload) ? payload : [] };
      return { ...state, ...newState };

    case SEND_COLLECTION_NOTICE:
      newState = { last_message: { ...payload } };
      return { ...state, ...newState };

    case NEW_TEAM_EMAILS:
      const { email_cc_collection, email_collection } = payload
      const team = get(state, 'teamCollection', {})
      newState = { teamCollection: { ...team, email_cc_collection, email_collection } }
      return { ...state, ...newState }

    case NEW_TEAM_DATA:
      newState = { teamCollection: payload }
      return { ...state, ...newState }

    case RESET_ACCOUNT:
    case LOG_OUT:
      newState = { initialState }
      return { ...state, ...initialState };

    default:
      return state;

  } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/collectionReducer.js